import React, { useContext, useEffect, useRef } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import searchIcon from "@public/img/search.svg";
import closeIcon from "@public/img/close.svg";
import bellIcon from "@public/img/bell.svg";
import bellLimeIcon from "@public/img/bell-lime.svg";
import fireRedIcon from "@public/img/fire-red.svg";
import notificationBadgeIcon from "@public/img/notification-badge.svg";
import { Movie, SearchResult, SearchResultAgent } from "@/entry/server/movie";
import { videoRepo } from "@/repo/video-repo";
import { ASSETS_BASE_URL } from "@/utils/constants";
import imdbIcon from "@public/img/imdb.svg";
import noPersonIcon from "@public/img/no-person.png"
import { AppContextType, WonmovContext } from "@/context/app-context";
import logoutIcon from "@public/img/logout.svg";
import chevronDownIcon from "@public/img/chevron-down.svg";
import ticketIcon from "@public/img/ticket.svg";
import settingIcon from "@public/img/setting.svg";
import dashboardIcon from "@public/img/dashboard.svg";
import starIcon from "@public/img/star.svg";
import { userRepo } from "@/repo/user-repo";
import { useHistory } from "react-router-dom";
import { NotificationData } from "@/entry/server/app";
import { appRepo } from "@/repo/app-repo";

export default function HeaderButtons() {
    return (
        <div className="site-header__actions">
            <Notifications />
            <SimpleSearch />
            <LoginBtn />
        </div>
    );
}

function LoginBtn() {
    const { isLoggedIn, user, vipData, setIsLoggedIn, setUser, setVipData, setNotification } = useContext<AppContextType>(WonmovContext);

    const [isLoading, setIsLoading] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const history = useHistory()

    const logout = async () => {
        if (isLoading) return;
        setIsLoading(true);
        const res = await userRepo.logout();
        setIsLoading(false);
        if (!res.status) {
            setNotification({ type: "danger", message: res.message });
            return;
        }
        setIsLoggedIn(false);
        setUser(null);
        setVipData(null);
        setNotification({ type: "success", message: "خروج با موفقیت انجام شد" });
        history.replace('/')
    }

    const vipActive = vipData && vipData.is_vip;
    var loginClass = "site-header__login-wrap";
    if (menuOpen) loginClass += " is-open";

    function focusFirstLoginItem() {
        window.setTimeout(function () {
            var menu = document.querySelector(".site-header__login-dropdown");
            if (!menu) return;
            var first = menu.querySelector("a, button");
            if (first && (first as HTMLElement).focus) {
                (first as HTMLElement).focus();
            }
        }, 0);
    }

    return (
        <div
            className={loginClass}
            data-tv-trap={isLoggedIn && menuOpen ? "" : undefined}
        >
            <Link to={isLoggedIn ? "/profile" : "/auth"}
                className="site-header__login-link"
                data-tv-close={isLoggedIn && menuOpen ? "" : undefined}
                onClick={function (e) {
                    if (!isLoggedIn) return;
                    e.preventDefault();
                    setMenuOpen(!menuOpen);
                }}
                onKeyDown={function (e) {
                    if (!isLoggedIn) return;
                    var which = e.keyCode || 0;
                    if (e.key !== "ArrowDown" && which !== 40) return;
                    e.preventDefault();
                    e.stopPropagation();
                    setMenuOpen(true);
                    focusFirstLoginItem();
                }}
            >
                {isLoggedIn ? user?.name : "ورود و ثبت نام"}
            </Link>

            {isLoggedIn && (
                <div className="site-header__login-dropdown">
                    <div className="site-header__login-card">
                        <div className="site-header__login-vip-row">
                            <img src={starIcon} alt="star" />
                            <p className="site-header__login-vip-label">اشتراک باقی مانده:</p>
                            <Link to="/profile/subscription" className="site-header__login-renew">
                                <img src={chevronDownIcon} alt="vip" />
                                <span>تمدید</span>
                            </Link>
                            <div className={`site-header__login-vip-badge ${vipActive ? "is-active" : "is-inactive"}`}>
                                {vipActive ? vipData.days_left + " روز" : "بدون اشتراک"}
                            </div>
                        </div>

                        <hr className="site-header__login-divider" />

                        <Link to="/profile" className="site-header__login-menu-link">
                            <span>پروفایل</span>
                            <img src={dashboardIcon} alt="پروفایل" />
                        </Link>
                        <Link to="/profile/tickets" className="site-header__login-menu-link">
                            <span>تیکت‌ها</span>
                            <img src={ticketIcon} alt="تیکت‌ها" />
                        </Link>
                        <Link to="/profile/settings" className="site-header__login-menu-link">
                            <span>ویرایش پروفایل</span>
                            <img src={settingIcon} alt="ویرایش پروفایل" />
                        </Link>

                        <hr className="site-header__login-divider" />

                        <button type="button" className="site-header__login-logout" onClick={logout}>
                            <span>خروج</span>
                            {isLoading ? <div className="white-loader" /> : <img src={logoutIcon} alt="خروج" />}
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

function SimpleSearch() {
    const [showSearch, setShowSearch] = useState(false);
    const [searchText, setSearchText] = useState("");
    const searchRef = useRef<HTMLInputElement>(null);
    const searchDivRef = useRef<HTMLDivElement>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [searchResult, setSearchResult] = useState<SearchResult | null>(null);
    const searchRequestId = useRef(0);

    useEffect(() => {
        if (showSearch) {
            if (searchRef.current) {
                searchRef.current.focus();
            }
        } else {
            if (searchRef.current) {
                searchRef.current.blur();
            }
            setSearchText("");
            setSearchResult(null);
            setIsLoading(false);
            searchRequestId.current = searchRequestId.current + 1;
        }
    }, [showSearch]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (searchDivRef.current && !searchDivRef.current.contains(event.target as Node)) {
                setShowSearch(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    const handleSearch = async (text: string) => {
        if (text.length < 2) {
            setSearchResult(null);
            return;
        }

        const currentRequestId = searchRequestId.current + 1;
        searchRequestId.current = currentRequestId;

        setIsLoading(true);
        const result = await videoRepo.search({ s: text, page: 1, limit: 5 });
        if (searchRequestId.current !== currentRequestId) {
            return;
        }
        setIsLoading(false);
        if (result.status && result.data) {
            setSearchResult(result.data);
        }
    }

    const showResults = showSearch && (isLoading || searchResult);

    return (
        <div
            className="site-header__search"
            ref={searchDivRef}
            data-tv-trap={showSearch ? "" : undefined}
        >
            <button
                type="button"
                className="site-header__action-btn"
                data-tv-close={showSearch ? "" : undefined}
                onClick={() => setShowSearch(!showSearch)}
            >
                <img src={showSearch ? closeIcon : searchIcon} alt="جستجو" />
            </button>

            <div className={`site-header__search-input-wrap${showSearch ? " is-open" : ""}`}>
                <input
                    type="text"
                    className="site-header__search-input"
                    placeholder="جستجو نام فیلم، بازیگر، کد imdb و ..."
                    ref={searchRef}
                    value={searchText}
                    onChange={(e) => {
                        setSearchText(e.target.value);
                        handleSearch(e.target.value);
                    }}
                />
            </div>

            <div className={`site-header__search-results custom-scrollbar${showResults ? " is-open" : ""}${isLoading && !searchResult ? " is-loading" : ""}`}>
                {isLoading && <div className="green-loader"></div>}

                {!isLoading && searchResult && searchResult.movies.length > 0 && (
                    <>
                        {searchResult.agent && <SearchResultAgentItem agent={searchResult.agent} />}

                        {searchResult.movies.map((movie) => (
                            <SearchResultMovieItem key={movie.id} movie={movie} />
                        ))}

                        <Link to={`/search?s=${searchText}`} className="site-header__search-view-all">
                            مشاهده همه
                        </Link>
                    </>
                )}

                {!isLoading && searchResult && searchResult.movies.length === 0 && (
                    <p className="site-header__search-no-result">موردی یافت نشد</p>
                )}
            </div>
        </div>
    );
}

function SearchResultMovieItem({ movie }: { movie: Movie }) {
    const posterSrc =
        movie.thumbnail && movie.thumbnail.indexOf("http") === 0
            ? movie.thumbnail
            : ASSETS_BASE_URL + (movie.thumbnail ? movie.thumbnail : "");

    return (
        <Link to={"/" + movie.type + "/" + movie.id + "/" + movie.slug + "/"} className="site-header__search-result-item">
            <img src={posterSrc} alt={movie.title} className="site-header__search-result-poster" />

            <div className="site-header__search-result-info">
                <p className="site-header__search-result-title">{movie.title}</p>
                <p className="site-header__search-result-subtitle">{movie.fa_title}</p>

                <div className="site-header__search-result-imdb">
                    <img src={imdbIcon} alt="imdb" />
                    {movie.imdb_rate > 0 ? (
                        <span className="ltr">
                            {movie.imdb_rate}
                            <small> / 10</small>
                        </span>
                    ) : (
                        <span><small>N/A</small></span>
                    )}
                </div>
            </div>
        </Link>
    );
}

function SearchResultAgentItem({ agent }: { agent: SearchResultAgent }) {
    const posterSrc = agent.image.startsWith("http") ? agent.image : `${ASSETS_BASE_URL}${agent.image.replace('files/', '')}`;
    return (
        <Link to={`/${agent.type}s/${agent.slug}/`} className="site-header__search-result-item">
            {agent.image.length > 0 ? (
                <img src={posterSrc} alt={agent.name} className="site-header__search-result-poster" />
            ) : (
                <img src={noPersonIcon} alt={agent.name} className="site-header__search-result-poster" />
            )}

            <div className="site-header__search-result-info">
                <p className="site-header__search-result-title">{agent.name}</p>
                <p className="site-header__search-result-role">{agent.type === "actor" ? "بازیگر" : "کارگردان"}</p>
            </div>
        </Link>
    );
}

function Notifications() {
    const { isLoggedIn, hasUnreadNotifications, setHasUnreadNotifications, setNotification } = useContext<AppContextType>(WonmovContext);
    const [notifications, setNotifications] = useState<NotificationData[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const notificationsRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (notificationsRef.current && !notificationsRef.current.contains(event.target as Node)) {
                setShowNotifications(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const fetchNotifications = async () => {
        const nextShowNotifications = !showNotifications;
        setShowNotifications(nextShowNotifications);
        if (!nextShowNotifications || isLoading || notifications.length > 0) return;

        setIsLoading(true);
        const res = await appRepo.getNotifications(1);
        setIsLoading(false);
        if (!res.status) {
            setNotification({ type: "danger", message: res.message });
            return;
        }
        setNotifications(res.data!);
        setHasUnreadNotifications(false);

        if (hasUnreadNotifications) {
            appRepo.markAllNotificationsAsRead();
        }
    };

    if (!isLoggedIn) return null;

    return (
        <div
            className="site-header__notify"
            ref={notificationsRef}
            data-tv-trap={showNotifications ? "" : undefined}
        >
            <div className="site-header__notify-trigger">
                <button
                    type="button"
                    className="site-header__action-btn"
                    data-tv-close={showNotifications ? "" : undefined}
                    onClick={fetchNotifications}
                >
                    <img src={showNotifications ? closeIcon : bellIcon} alt="اعلان‌ها" />
                </button>
                {hasUnreadNotifications && !showNotifications && (
                    <img
                        src={notificationBadgeIcon}
                        alt=""
                        className="site-header__notify-badge"
                    />
                )}
            </div>

            <div className={`site-header__notify-panel${showNotifications ? " is-open" : ""}`}>
                <div className="site-header__notify-list custom-scrollbar">
                    {isLoading && (
                        <div className="site-header__notify-loading">
                            <div className="green-loader" />
                        </div>
                    )}

                    {!isLoading && notifications.length === 0 && (
                        <p className="site-header__notify-empty">اعلانی وجود ندارد</p>
                    )}

                    {!isLoading && notifications.map((notification) => (
                        <NotificationItem key={notification.id} notification={notification} />
                    ))}
                </div>
            </div>
        </div>
    );
}

function NotificationItem({ notification }: { notification: NotificationData }) {
    const isDuelGame = notification.type === "duel_game";

    return (
        <div className="site-header__notify-item">
            <div className="site-header__notify-item-icon">
                <img src={isDuelGame ? fireRedIcon : bellLimeIcon} alt="" />
            </div>
            <div className={`site-header__notify-item-body${isDuelGame ? " is-duel" : ""}`}>
                <p className={`site-header__notify-item-title${isDuelGame ? " is-duel" : ""}`}>
                    {notification.title}
                </p>
                <p className="site-header__notify-item-text">
                    {notification.content}
                </p>
                {isDuelGame && (
                    <Link to="/competition" className="site-header__notify-item-link">
                        بزن بریم!
                    </Link>
                )}
            </div>
        </div>
    );
}
